import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import {
  TIPO_MASCARA_FOLLOW_UP_LIST,
} from './tipoMascaraFollowUpUtils';

export default function QCXSelectTipoMascaraAutocomplete({
  label,
  name,
  initialValues,
  disabled,
  ...restProps
}) {
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const value = TIPO_MASCARA_FOLLOW_UP_LIST
      .find((item) => (
        item?.value === _.get(initialValues, name)
      ));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue('');
    }
  }, [initialValues]);

  const filterOptions = useMemo(() => (
    createFilterOptions({
      stringify: (option) => (
        option.label + option.value
      ),
    })
  ), []);

  const getOptionLabel = useCallback((item) => (
    item?.label || ''
  ), []);

  const getOptionValue = useCallback((item) => (
    item?.value || ''
  ), []);

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={TIPO_MASCARA_FOLLOW_UP_LIST}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      disabled={disabled}
      {...restProps}
    />
  );
}
